import React from 'react'
import {Link} from 'gatsby'
import InfoButton from './InfoButton.js'
import   "./animation.module.css"

 class Info extends React.Component {
 	

 	componentDidMount(){
 		document.querySelector('html').style.overflow="hidden";
 		document.querySelector('body').style.overflow="hidden";
 	}

 	

	render (){
		return (

				<div  className="fadeIn" 
					  css={{position:`absolute`,
					          top:`10%`,
					          left:`10%`,
					          zIndex:`10000`,
					          '@media(min-width:500px)':{
					      	 		top:'27%'
					      	 	},
					      	 '@media(min-width:800px)':{
					      	 		top:'25%'
					      	 	}
					        }}>

					<h1 style={{fontFamily:'Noto Serif SC',
								fontWeight:'500',
								fontSize:'36px',
								marginBottom:'10px',
								color:'#333'}}>
								Iisha Small
								</h1>
					 <h2 style={{ fontFamily:'Droid Sans',fontWeight:'700',fontSize:'18px'}}>Interactive Developer</h2> 
					<p style={{ maxWidth:'400px',
								fontFamily:'Droid Sans', 
								fontWeight:'400',
								fontSize:'16px',
								color:'#333',
								marginBottom: '20px'
							}}>
						 I have experience in Front End Development creating many multimedia kiosks, responsive HTML emails, Veeva IVA presentations and banners using HTML5, Sass, 
						 Javascript, JQuery, Bootstrap, Vue and Gatsby for advertising agencies. I am also well versed in the front end styling and maintenance of WordPress websites. I have guided creative teams in the best technical practices to achieve their creative goals and satisfy the technical specs required for the digital space.
					</p>
						 
					<Link to="/loginpage"> <InfoButton/> </Link>

					
					
				</div>

			)
	}
}

export default Info;
